export default __webpack_public_path__ + "static/media/3.1744e226.png";